<!-- eslint-disable vue/no-v-html -->
<template>
  <BModal
    :id="id"
    hide-header
    hide-footer
    centered
    content-class="rounded-2xl border-0"
    size="md"
    @hidden="$emit('close')"
  >
    <div class="text-center p-[.5rem]">
      <!-- Warning Icon -->
      <img
        :src="icon"
        alt="Konfirmasi"
        class="mx-auto mb-[1rem]"
        width="80px"
      >

      <!-- Title -->
      <h3 class="font-bold text-[18px] md:text-[20px] text-[#333333] mb-[.75rem] leading-snug">
        {{ title }}
      </h3>

      <!-- Message -->
      <p
        class="text-[#626262] text-[14px] leading-relaxed mb-[1.5rem] px-[.25rem]"
        v-html="message"
      />

      <!-- Action Buttons -->
      <div class="flex flex-row gap-[1rem] justify-center">
        <BButton
          variant="outline-primary"
          class="w-full !rounded-lg !border-[#F95031] !text-[#F95031] hover:!bg-[#F95031] hover:!text-white font-semibold py-[0.625rem]"
          :disabled="loading"
          @click="$emit('cancel')"
        >
          {{ cancelText }}
        </BButton>

        <BButton
          variant="primary"
          class="w-full !rounded-lg bg-[#F95031] text-white font-semibold py-[0.625rem]"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          <BSpinner
            v-if="loading"
            small
            class="mr-[.25rem]"
          />
          {{ confirmText }}
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalConfirmation',
  props: {
    id: {
      type: String,
      default: 'modal-confirmation',
    },
    title: {
      type: String,
      default: 'Konfirmasi',
    },
    message: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Ya, Selesaikan',
    },
    cancelText: {
      type: String,
      default: 'Batal',
    },
    icon: {
      type: String,
      default: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
